import CryptoJS from 'crypto-js';

export const encryptSecret = (secret: string, backupPassword: string): string => {
  return CryptoJS.AES.encrypt(secret, backupPassword).toString();
};

export const decryptSecret = (encryptedSecret: string, backupPassword: string): string => {
  const bytes = CryptoJS.AES.decrypt(encryptedSecret, backupPassword);
  return bytes.toString(CryptoJS.enc.Utf8);
}; 